import { render, staticRenderFns } from "./InternalDropdownProfile.vue?vue&type=template&id=35209910"
import script from "./InternalDropdownProfile.vue?vue&type=script&lang=js"
export * from "./InternalDropdownProfile.vue?vue&type=script&lang=js"
import style0 from "./InternalDropdownProfile.vue?vue&type=style&index=0&id=35209910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports